'use client';

import React from 'react';
import Image from 'next/image';
import styled from 'styled-components';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import Breadcrumbs from '@/components/Breadcrumbs';

export default function CareersPage() {
  return (
    <>
      <Header handleClickIndex={() => {}} />
      <div className="header-gap-creator"></div>
      <Breadcrumbs items={[{ label: 'Careers' }]} />

      <main className="container-0">
        {/* Hero Section */}
        <HeroWrapper>
          <Image
            className="careers"
            src="/assets/careers-hero.webp"
            alt="careers"
            width={1800}
            height={712}
            priority
          />
        </HeroWrapper>

        {/* Career Information Section */}
        <CareerElement1Wrapper>
          <div className="cleaner w-container">
            <div className="main-vehicle-row w-row">
              <div className="content-grid">
                <div className="content-item">
                  <h1 className="main-header">Green Filter is an equal opportunity employer.</h1>
                  <p className="large-paragraph gray reviews">
                    We are looking for team players who work well with others and are open to learning new skills.
                  </p>
                  <p className="large-paragraph gray reviews">
                    If you think you have what it takes to join our team of dedicated support and production staff we
                    would love to hear from you!
                  </p>
                  <br />
                  <p className="large-paragraph gray reviews">
                    To apply, email your resume and the position you are interested in to{' '}
                    <a href="mailto:accounting@greenfilterusa.com">accounting@greenfilterusa.com</a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </CareerElement1Wrapper>

        {/* TODO: Add Gallery component here when Home page components are migrated */}
      </main>

      <Footer />
    </>
  );
}

const HeroWrapper = styled.div`
  .careers {
    margin-top: 100px;
    width: 100%;
    height: auto;
  }
`;

const CareerElement1Wrapper = styled.div`
  position: relative;
  margin-top: 0%;
  padding: 0 5% 20%;
  background-color: #fff;
  background-image: url('/assets/green-gradient-blue.webp');
  background-position: 50% 100%;
  background-size: contain;
  background-repeat: no-repeat;
  text-align: center;

  .main-header {
    margin-top: 0;
  }

  .cleaner {
    margin-top: 50px;
    margin-bottom: 100px;
  }

  .content-grid {
    width: 100%;
  }

  .content-item {
    width: 100%;
  }
`;
